import { render } from "./index.vue?vue&type=template&id=96f70afc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=96f70afc&lang=less&scoped=true"

import exportComponent from "D:\\Project\\Carryglobal\\GlobalLinkVIPNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f70afc"]])

export default __exports__